import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../../auth.service';
import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { LocalStorageDataModel } from '@AppCore/constants/local-storage-data-model';
import { SharedService } from '@AppRoot/shared/services/shared.service';
import { filter, pairwise } from 'rxjs/operators';
import { NavigationService } from '@AppCore/services/navigation-service.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  otpSent: boolean = false;
  reSendOtp: boolean = false;
  phoneNumber: string = '';

  @Output() loggedIn = new EventEmitter<boolean>();
  @Input() minimal = false;
  @Input() title = 'Login';
  isMobileScreen: boolean = false;
  private previousUrl: string | null = null;

  constructor(
    private _route: Router,
    private globalUtilityService: GlobalUtilityService,
    private _sharedService: SharedService,
    private navigationService: NavigationService
  ) {}

  ngOnInit() {
    this.isMobileScreen = this.globalUtilityService.isMobile();
  }

  handleOtpSenSuccess(data: string) {
    this.phoneNumber = data;
  }

  handleLogin() {
    const backUrl = this.navigationService.getPreviousUrl() || '/';
    this._sharedService.getCartItems().subscribe(() => {
      this.globalUtilityService.hideLoader();
    });
    this._route.navigateByUrl(backUrl);
    this.loggedIn.emit(true);
  }

  navigateBackUrl() {
    const backUrl = this.navigationService.getPreviousUrl() || '/';
    console.log(this.navigationService.getPreviousUrl());
    this._route.navigateByUrl(backUrl);
  }
}
